define((require) => {
    "use strict";

    var Backbone         = require("backbone"),
        ExperienceModel  = require("shared/ui/experience/ExperienceModel"),
        PublishableState = require("util/PublishableState"),
        LoggedIn         = require("shared/security/LoggedIn"),
        RestApi          = require("shared/services/RestApi");

    /**
     * A collection of experiences.
     *
     * @class ExperienceCollection
     * @constructor
     *
     */
    var ExperienceCollection = Backbone.Collection.extend({

        model: ExperienceModel,

        url: function() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.EXPERIENCES);
        },

        comparator: function(experienceModel) {
            return -experienceModel.getEditedAt();
        },

        /**
         * Returns a new <tt>Backbone.Collection</tt> (not a <tt>ExperienceCollection</tt>), that contains
         * all <i>non-empty</i> experiences from *this* experience collection.
         *
         * @return {Backbone.Collection} A collection that contains all <i>non-empty</i> experiences
         * from *this* experience collection.
         */
        filterNonEmptyExperiences: function() {
            return new ExperienceCollection(this.filter((experience) => {
                return !experience.isEmpty();
            }));
        },

        /**
         * Counts the experiences that are not variants of other experiences and are not empty.
         *
         * @returns {Number} Amount of not empty master experiences
         */
        noneEmptyExperienceCount: function() {
            return this.filterNonEmptyExperiences().length;
        },

        /**
         * Filter out the experiences that are not pushed.
         *
         * @returns {ExperienceCollection} a collection of filtered experiences.
         */
        filterPushedExperiences: function() {
            // FIXME: We tend to see weird behavior when referencing the same models from multiple collections
            return new ExperienceCollection(this.filter((experience) => {
                return experience.hasAtLeastState(PublishableState.PUSHED);
            }));
        },

        /**
         * Helper function that runs through every experience model and returns
         * true if all of them are empty (or if there are no experiences).
         *
         * @return {Boolean}
         */
        allExperiencesAreEmpty: function() {
            return this.every((experience) => {
                return experience.isEmpty();
            });
        }
    });

    return ExperienceCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/ExperienceCollection.js